import React, { useContext, useState } from 'react'
import { VerificationButton } from 'src/components/Global/Button/Button'
import { ForgotWrapper, FormWrapper } from './style'
import { InputLogin } from 'src/components/Global/Input/Input'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { forgotPasswordAction } from 'src/redux/actions/auth'
import { useDispatch } from 'react-redux'
import { SnackbarContext } from 'src/contexts/Snack'
import useSnackbar from 'src/hooks/useSnackBar'
import { validateEmail } from 'src/components/Validate/validate'
const ForgotForm = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const dispatch = useDispatch()
  const [userData, setUserData] = useState({
    email: '',
  })
  const snackbarCtx: any = useContext(SnackbarContext)

  const { state: snackbarState } = snackbarCtx

  const { email } = userData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }

  const ResetPassword = (e: any) => {
    e.preventDefault()
    const error = validateEmail(userData)
    if (error.error) {
      snackbar.trigger({
        message: error.error.message,
        severity: 'warning',
      })
      return
    }
    dispatch(forgotPasswordAction({ userData, onSuccess, onError }))
    setLoading(true)
  }

  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: error,
      severity: 'error',
    })
  }
  return (
    <ForgotWrapper>
      <div className="welcome">
        <h1>Let’s recover your account</h1>
        <p>
          Enter your email address to receive
          <br /> instructions on how to reset your password
        </p>
      </div>
      <FormWrapper>
        <div className="each-form">
          <label>Email address</label>
          <InputLogin
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
          />
        </div>
        <div className="each-form revert">
          <VerificationButton onClick={ResetPassword}>
            Reset Password {loading && <Spinner />}
          </VerificationButton>
        </div>
      </FormWrapper>
    </ForgotWrapper>
  )
}

export { ForgotForm }
